/**
 * Migration 104 gives search_surfaceable_emails a "window ladder": when the caller
 * doesn't pass an explicit date range, the RPC probes 3mo -> 1yr -> 4yr -> all-time
 * and stops at the first window that fills p_limit. The RPC's response doesn't say
 * which window it used, so a broad, common-term search can silently look complete
 * while older matches exist outside the window that filled first.
 *
 * This is a client-side heuristic, not a report of the server's real window: when
 * the result count hits the limit and no explicit range was given, we assume the
 * ladder stopped early and warn. A search that returns fewer than `limit` rows means
 * the ladder reached "all-time" without filling up, so nothing was truncated.
 */
export function searchWindowHint(
  results: { received_at: string | null }[],
  limit: number,
  hasExplicitRange: boolean,
): { truncated: boolean; oldestIso: string | null } {
  const withDates = results.filter((r): r is { received_at: string } => !!r.received_at);
  const oldestIso =
    withDates.length === 0
      ? null
      : withDates.reduce((min, r) => (r.received_at < min ? r.received_at : min), withDates[0].received_at);

  const truncated = !hasExplicitRange && results.length >= limit;

  return { truncated, oldestIso };
}
